<template>
  <card class="m-0 mb-4 p-0">
    <b-row>
      <b-col>
        <base-input
          mode="passive"
          v-model="search"
          placeholder="Search Dentists"
          v-debounce:300ms="doSearch"
        >
        </base-input>

        <b-form-checkbox
          switch
          size="sm"
          class="pt-3 pb-3"
          v-model="isActive"
          @change="doSearch"
          >Active Companies</b-form-checkbox
        >
      </b-col>
      <b-col>
        <div class="text-right">
          <b-button variant="outline-light" @click="syncMailChimp">
            <loading-svg
              v-if="doingMailChimp"
              height="18"
              width="18"
            ></loading-svg>

            <i class="fa-brands fa-mailchimp" v-if="!doingMailChimp"></i
          ></b-button>
          <b-button variant="primary" @click.prevent="goNewCompany"
            >New Company</b-button
          >
        </div>
      </b-col>
    </b-row>

    <table class="table border">
      <tr>
        <th class="align-middle text-center">
          ID
        </th>
        <th class="align-middle text-left">
          Start Date
        </th>

        <th class="align-middle text-left">
          System
        </th>
        <th class="align-middle text-left">
          Practice Name
        </th>

        <th class="text-right align-middle">30 Days</th>
        <th class="text-right align-middle">7 Days</th>
        <th class="text-right align-middle">24 Hours</th>

        <th class="align-middle text-right">
          Action
        </th>
      </tr>
      <tr v-for="item in companies" v-bind:key="item.id">
        <td class="align-middle">
          {{ item.id }}
        </td>
        <td class="align-middle">
          {{ item.created | moment("MM/DD/YYYY") }}<br />
        </td>

        <td class="align-middle">
          {{ item.systemName }}
        </td>

        <td class="align-middle w-100" style="white-space: normal !important;">
          {{ item.companyName }}
        </td>

        <td class="align-middle text-right">
          {{ (item.last30Amount / 100) | currency }}
        </td>
        <td class="align-middle text-right">
          {{ (item.last7Amount / 100) | currency }}
        </td>
        <td class="align-middle text-right">
          {{ (item.last24HoursAmount / 100) | currency }}
        </td>

        <td class="align-middle text-center">
          <b-button
            variant="primary"
            @click.prevent="editCompany(item.id)"
            size="sm"
            class="shadow-none"
            ><i class="fa-solid fa-pen" style="font-size: 0.8em;"></i
          ></b-button>
          <b-button
            variant="success"
            @click.prevent="login(item.id)"
            size="sm"
            class="shadow-none"
            ><i class="fa-solid fa-arrow-up-right"></i
          ></b-button>
        </td>
      </tr>
    </table>

    <b-pagination
      align="center"
      class="mt-3"
      v-model="page"
      :total-rows="totalRows"
      :per-page="rows"
      @change="pageChange"
    ></b-pagination>
  </card>
</template>

<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import Axios from "axios";

export default {
  name: "companies",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      search: "",
      rows: 25,
      page: 1,
      totalRows: null,
      isActive: true,
      companies: null,
      cancelationTokens: [],
      doingMailChimp: false,
      cc: true,
    };
  },
  inject: ["companyService"],
  methods: {
    pageChange(pg) {
      this.bind(pg);
    },
    async syncMailChimp() {
      this.doingMailChimp = true;
      let r = await this.$client.post("/api/company/syncMailChimp");
      if (r.data.isSuccess) {
        this.$emitter.emit("success-confirm", {
          message: `Synced ${r.data.value.count} items with Mailchimp`,
          title: "Mailchimp Sync Complete",
        });
      }
      this.doingMailChimp = false;
    },
    async login(companyId) {
      await this.companyService.loginUnderCompany(companyId);
    },
    goNewCompany() {
      location.href = "/#/admin/newCompany/";
    },
    editCompany(companyId) {
      location.href = "/#/admin/company/" + companyId;
    },
    doSearch() {
      this.bind(1);
    },

    async bind(pg) {
      this.companies = [];
      var self = this;
      var r = await self.$client.get(
        `/api/company/companies?search=${self.search}&isActive=${self.isActive}&rows=${this.rows}&page=${pg}`
      );
      if (r.data.value.length > 0) this.totalRows = r.data.value[0].rows;
      else this.totalRows = 0;

      self.companies = r.data.value;
    },
  },
  async created() {
    await this.bind(1);
  },
  beforeDestroy() {
    this.cancelActiveRequests();
  },
};
</script>

<style>
body #companiesTable tr:hover {
  background-color: #f6f9fc;
  cursor: pointer;
}
</style>
